import React from 'react';

import { calls } from './content';
import { contactsRoute } from './routes';

import { Route, RouterProvider } from './components/Router/Router';
import { PhoneFrame } from './components/PhoneFrame/PhoneFrame';
import { GameBridgeProvider, useGameBridge } from './components/SDKProvider/SDKProvider';
import { AudioProvider, useMuteSource } from './components/AudioProvider/AudioProvider';
import { InterstitialState, RewardedState } from './components/SDKProvider/sdk';
import { SoundsProvider } from './components/AudioProvider/SoundsProvider';

const WithActivityMute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
    const bridge = useGameBridge();
    const interstitialSound = useMuteSource()[1];
    const rewardedSound = useMuteSource()[1];
    const windowSound = useMuteSource()[1];

    React.useEffect(() => {
        const interstitialHandler = (state: InterstitialState) => {
            if (state === 'opened') {
                interstitialSound.mute();
            } else {
                interstitialSound.unmute();
            }
        };

        const rewardedHandler = (state: RewardedState) => {
            if (state === 'opened') {
                rewardedSound.mute();
            } else {
                rewardedSound.unmute();
            }
        };

        interstitialHandler(bridge.advertisement.interstitialState);
        rewardedHandler(bridge.advertisement.rewardedState);

        bridge.advertisement.on('interstitial_state_changed', interstitialHandler);
        bridge.advertisement.on('rewarded_state_changed', rewardedHandler);

        return () => {
            bridge.advertisement.off('interstitial_state_changed', interstitialHandler);
            bridge.advertisement.off('rewarded_state_changed', rewardedHandler);
            interstitialSound.unmute();
            rewardedSound.unmute();
        };
    }, [bridge, interstitialSound, rewardedSound]);

    React.useEffect(() => {
        window.addEventListener('blur', windowSound.mute);
        window.addEventListener('focus', windowSound.unmute);

        return () => {
            window.removeEventListener('blur', windowSound.mute);
            window.removeEventListener('focus', windowSound.unmute);
            windowSound.unmute();
        };
    }, [windowSound]);

    return children;
};

export const App: React.FC = () => {
    return (
        <GameBridgeProvider>
            <AudioProvider>
                <SoundsProvider>
                    <WithActivityMute>
                        <RouterProvider initialRoute={contactsRoute({ calls })}>
                            <PhoneFrame>
                                <Route />
                            </PhoneFrame>
                        </RouterProvider>
                    </WithActivityMute >
                </SoundsProvider>
            </AudioProvider>
        </GameBridgeProvider>
    );
};
